$(document).ready(function () {
  /* about */
  if (document.querySelector('.about__slider-content')) {
    const swiperAboutNav = new Swiper('.about__nav-slider', {
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
    });

    const swiperAbout = new Swiper('.about__slider-content', {
      slidesPerView: 1,
      pagination: {
        el: '.about__slider .swiper-pagination',
        type: 'custom',
        renderCustom: function (swiper, current, total) {
          return `<span class="swiper-pagination-current">  ${('0' + current).slice(-2)}  </span>/
                  <span class="swiper-pagination-total"> ${('0' + total).slice(-2)} </span> `
        }
      },
      thumbs: {
        swiper: swiperAboutNav,
      },
      loop: true,
      loopFillGroupWithBlank: true,
      navigation: {
        prevEl: '.about__slider .swiper-nav__arrow-prev',
        nextEl: '.about__slider .swiper-nav__arrow-next',
      }
    });
  }

  /* partners */
  const cardSlides = new Swiper('.card-slides', {
    //slidesPerView: 'auto',
    slidesPerView: 3,
    spaceBetween: 0,
    speed: 1000,
    loop: true,
    loopFillGroupWithBlank: true,
    //slideToClickedSlide: true,
    pagination: {
      el: '.card-slides .swiper-pagination',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        return `<span class="swiper-pagination-current">  ${('0' + current).slice(-2)}  </span>/
          <span class="swiper-pagination-total"> ${('0' + total).slice(-2)} </span> `
      }
    },
    navigation: {
      prevEl: '.card-slides .swiper-nav__arrow-prev',
      nextEl: '.card-slides .swiper-nav__arrow-next',
    },
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
      320: {
        slidesPerView: 1,
      },
    },
  });
  new Swiper('.centered-slides', {
    slidesPerView: 3,
    spaceBetween: 0,
    speed: 1000,
    loop: true,
    loopFillGroupWithBlank: true,
    centeredSlides: true,
    pagination: {
      el: '.centered-slides .swiper-pagination',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        return `<span class="swiper-pagination-current">  ${('0' + current).slice(-2)}  </span>/
          <span class="swiper-pagination-total"> ${('0' + total).slice(-2)} </span> `
      }
    },
    navigation: {
      prevEl: '.centered-slides .swiper-nav__arrow-prev',
      nextEl: '.centered-slides .swiper-nav__arrow-next',
    },
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
      320: {
        slidesPerView: 1,
      },
    },
  });

  /* technology */
  if ($('.technology__slider').length > 0) {
    let countSlider = document.getElementById('swiper_pagination_total').textContent;
    let firstSlider = document.getElementById('swiper_pagination_current').textContent;
    $(".swiper-pagination-current", ".technology__nav").html("0"+firstSlider);
    $(".swiper-pagination-total", ".technology__nav").html("0"+countSlider);
    let swiperTech = new Swiper(".technology__slider", {
      slidesPerView: 1,
      autoHeight: true,
      loop: false,
      navigation: {
        prevEl: ".technology .swiper-nav__arrow-prev",
        nextEl: ".technology .swiper-nav__arrow-next",
      },
      on: {
        slideChange: function (e) {
          // $(".swiper-pagination-current", ".technology__nav").html( (+swiperTech.activeIndex + 1) );
          $(".swiper-pagination-current", ".technology__nav").html("0" + (+swiperTech.activeIndex + 1));
          $(".swiper-pagination-total", ".technology__nav").html("0"+countSlider);
        },
      },
    });
  }

  /* smi */
  if ($('.smi__slider').length > 0) {
    let swiperSmi = new Swiper(".smi__slider", {
      slidesPerView: 'auto',
      autoHeight: true,
      spaceBetween: 30,
      /*
      freeMode: true,
      slideToClickedSlide:true,
      loop: true,
      loopFillGroupWithBlank: true,
      */
      scrollbar: {
        el: ".smi__slider .swiper-scrollbar",
        hide: false,
      },
      pagination: {
        el: '.smi__slider .swiper-pagination',
        type: 'custom',
        renderCustom: function (swiper, current, total) {
          return `<span class="swiper-pagination-current">  ${('0' + current).slice(-2)}  </span>/
                  <span class="swiper-pagination-total"> ${('0' + total).slice(-2)} </span> `
        }
      },
      navigation: {
        prevEl: '.smi__slider .swiper-nav__arrow-prev',
        nextEl: '.smi__slider .swiper-nav__arrow-next',
      },
      /*
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      */
    });
  }
  /* news*/
  if ($('.news__slider').length > 0) {
    let swiperNews = new Swiper(".news__slider", {
      direction: "vertical",
      slidesPerView: "auto",
      spaceBetween: 30,
      mousewheel: true,
      navigation: {
        prevEl: '.news__prev',
        nextEl: '.news__next',

      },

    });
  }
});